function AppAside(p) {
    return (
        <aside className="aside">
            <h1><img src="/icons/admin.png" alt="" /></h1>
            {p.children}
        </aside>
    );
}

export default AppAside;